

import React, { useState } from 'react';
import { isEmail } from 'validator';
import _memoize from 'lodash.memoize';
import memoizeOne from 'memoize-one';
import cx from 'classnames';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import { FormModal, Container, Row, Col, Button, Input, PhoneNumberInput, Dropdown, Text, Link } from '../../../ui-kit';

import '../styles/_contact-sales-modal.scss';










const REQUIRED_FIELDS = ['firstName', 'lastName', 'email', 'reason'];

const CONTACT_REASONS = [
'Exploring only',
'I want to produce a one-off video',
'Learn more about a subscription for Shootsta',
'Get a quote for a subscription',
'I need video for corporate comms',
'I need video for B2B marketing',
'I need video for sales',
'I need video for corporate training/HR',
'I want to work at Shootsta'];


function privacyPolicyClick() {
  window.open('https://shootsta.com/legal-stuff/', '_blank');
}

const isValidEmail = memoizeOne(isEmail);
const isValidText = (text) => Boolean(text);

function ContactSalesModal({
  visible,
  onSave,
  onClose,
  stayOpen,
  error,
  className
}) {
  const [userInput, setUserInput] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    jobTitle: '',
    department: '',
    reason: ''
  });

  const [saving, setSaving] = useState(false);
  const [formError, setError] = useState('');

  const [phoneNumberValid, setValidPhoneNumber] = useState(true);

  const updateInputField = _memoize((fieldName) => (result) => {
    setUserInput({
      ...userInput,
      [fieldName]: fieldName === 'reason' ?
      result.value :
      getStringValueFromGenericInput(result)
    });
  });

  const isValid = (fieldName) => {
    const field = userInput[fieldName];

    if (field === 'email') {return isValidEmail(field);}

    return isValidText(field);
  };

  const hasInvalidFields = () => !REQUIRED_FIELDS.every(isValid) || !phoneNumberValid;

  const onSaveForm = async () => {
    setSaving(true);

    if (hasInvalidFields()) {
      setError('Please enter valid form details');
      return setSaving(false);
    }

    if (formError.length > 0) {
      setError('');
    }

    if (onSave) {
      await onSave(userInput);
    }

    return setSaving(false);
  };

  return (
    <div className={cx('contact-sales-modal', className)}>
      <FormModal
        visible={visible}
        onClose={onClose}
        title="Contact Sales"
        subtitle="Not sure whether or not Pro is a perfect addition to your team’s workspace?"
        stayOpenOnSave={stayOpen}
        hideFooter>

        <Container fluid>
          <Row align="center">
            <Col sm={6} xs={12}>
              <Input
                label="First Name"
                validate={() => isValid('firstName')}
                onChange={updateInputField('firstName')}
                labelProps={{ required: true }} />

            </Col>
            <Col sm={6} xs={12}>
              <Input
                label="Last Name"
                validate={() => isValid('lastName')}
                onChange={updateInputField('lastName')}
                labelProps={{ required: true }} />

            </Col>
          </Row>
          <Row align="center">
            <Col sm={6} xs={12}>
              <Input
                label="Email"
                validate={() => isValid('email')}
                onChange={updateInputField('email')}
                labelProps={{ required: true }} />

            </Col>
            <Col sm={6} xs={12}>
              <PhoneNumberInput
                placeholder="xxxx-xxx-xxx"
                label="Phone Number"
                onChange={updateInputField('phoneNumber')}
                onValidate={setValidPhoneNumber}
                labelProps={{ required: true }} />

            </Col>
          </Row>
          <Input
            label="Job Title"
            onChange={updateInputField('jobTitle')} />

          <Input
            label="Department"
            onChange={updateInputField('department')} />

          <Dropdown
            onChange={updateInputField('reason')}
            options={CONTACT_REASONS}
            placeholder="Please Select"
            label="What drove you to contact us?"
            labelProps={{ required: true }}
            type="BUTTON" />

          <Text className="contact-sales-modal__disclaimer" block>
            <span>
              Shootsta needs the contact information you provide to us to
              contact you about our products and services.
              You may unsubscribe from these communications at any time.
              For information on how to unsubscribe,
              as well as our privacy practices and commitment to protecting your privacy,
              please review our
              {' '}
              <Link className="contact-sales-modal__link" onClick={privacyPolicyClick}>Privacy Policy</Link>
              .
            </span>
          </Text>
          {(formError || error) &&
          <Row>
              <Col>
                <Text danger>{formError || error || ''}</Text>
              </Col>
            </Row>}

          <Button
            className="contact-sales-modal__btn"
            busy={saving}
            disabled={hasInvalidFields()}
            onClick={onSaveForm}>

            Submit
          </Button>
        </Container>
      </FormModal>
    </div>);

}

export default ContactSalesModal;